import { useEffect, useState } from "react";

export function usePersistState<T>(key: string, initialValue: T) {
  const [state, setState] = useState<T>(
    JSON.parse(localStorage.getItem(key) ?? JSON.stringify(initialValue))
  );

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState] as const;
}
